import { useCallback } from 'react';
import { saveDefaultPurchase } from '../../providers-list/api';

const useSaveSellerLabelProviderDefaultFundingAmount = (sellerLabelProviderId) => {
  return useCallback(
    (amount) => {
      return saveDefaultPurchase(sellerLabelProviderId, amount);
    },
    [sellerLabelProviderId],
  );
};

export default useSaveSellerLabelProviderDefaultFundingAmount;
